







import DictMixin from '@/mixins/dict-mixin';
import ApproveServices from '@/services/approve';
import { mixins } from 'vue-class-component';
import { Component, Prop, PropSync } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class ApproveModal extends mixins(DictMixin) {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() detail!: any;

  appSrv = new ApproveServices();
  appTaskComment = '';

  async submitApprove() {
    if (!this.appTaskComment) {
      this.$message.error('请填写描述信息');
      return false;
    }
    let res = await this.appSrv.submitApprove({
      appTaskKind: this.DICT_VALUE('DICT_APPROVE_REF_TYPE', this.detail.type),
      appTaskComment: this.appTaskComment,
      refAppCode: this.detail.code,
      refAppType: this.detail.type,
      refAppUri: this.detail.uri,
      appStatus: this.detail.approveStatus
    });
    if (res) {
      this.$message.success('操作成功');
      this.appTaskComment = '';
      this.syncVisible = false;
    }
  }

  close() {
    this.syncVisible = false;
  }
}
